import React from 'react';
import styled from 'styled-components';

const StatisticSectionContainer = styled.div`
  margin: 0 1rem 1rem 0rem;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1px;
  padding: 15px;
  color: #505050;
`;

const StatisticSectionItems = styled.div`
  font-size: 18px;
  font-weight: 600;
  text-align: center;
`;

// const formatDateProp = dateObj => {
//   const options = {
//     weekday: 'short',
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric',
//   };
//   return dateObj.toLocaleDateString('en-US', options);
// };

const StatisticSection = ({
  // dateFilter,
  totalBookings,
  totalGuestCount,
  totalSeated,
  totalCancelled,
  // dontShowDateFilter,
  bookingFee,
}) => (
  <StatisticSectionContainer>
    <StatisticSectionItems
      style={{ textAlign: 'left', wordBreak: 'break-all' }}
    >
      Total Fee: ${parseFloat(bookingFee ?? 0).toFixed(2)}
    </StatisticSectionItems>
    <StatisticSectionItems>
      Total Booking: {totalBookings ?? 0}
    </StatisticSectionItems>
    <StatisticSectionItems>
      Guests: {totalGuestCount ?? 0}
    </StatisticSectionItems>
    <StatisticSectionItems>Seated: {totalSeated ?? 0}</StatisticSectionItems>
    <StatisticSectionItems>
      Cancelled: {totalCancelled ?? 0}
    </StatisticSectionItems>
  </StatisticSectionContainer>
);

export default StatisticSection;
